/*** IMPORTS FROM imports-loader ***/


/**
 * GIS Server APIs
 * A powerful suite of mapping, geospatial and location-based APIs for your applications and services.
 *
 * OpenAPI spec version: v1.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/ResponseListRestrictionActionResource', 'model/ResponseObject', 'model/ResponseRestrictionResponse', 'model/RestrictionActionResource', 'model/RestrictionResource', 'model/RestrictionsResponse'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/ResponseListRestrictionActionResource'), require('../model/ResponseObject'), require('../model/ResponseRestrictionResponse'), require('../model/RestrictionActionResource'), require('../model/RestrictionResource'), require('../model/RestrictionsResponse'));
  } else {
    // Browser globals (root is window)
    if (!root.GisServerApis) {
      root.GisServerApis = {};
    }
    root.GisServerApis.RestrictionApi = factory(root.GisServerApis.ApiClient, root.GisServerApis.ResponseListRestrictionActionResource, root.GisServerApis.ResponseObject, root.GisServerApis.ResponseRestrictionResponse, root.GisServerApis.RestrictionActionResource, root.GisServerApis.RestrictionResource, root.GisServerApis.RestrictionsResponse);
  }
}(this, function(ApiClient, ResponseListRestrictionActionResource, ResponseObject, ResponseRestrictionResponse, RestrictionActionResource, RestrictionResource, RestrictionsResponse) {
  'use strict';

  /**
   * Restriction service.
   * @module api/RestrictionApi
   * @version 1.0.0
   */

  /**
   * Constructs a new RestrictionApi. 
   * @alias module:api/RestrictionApi
   * @class
   * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the addActionsToRestrictionV1 operation.
     * @callback module:api/RestrictionApi~addActionsToRestrictionV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseObject} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Add actions to a specified restriction.
     * @param {String} restrictionId The ID of the restriction to be edit.
     * @param {Object} opts Optional parameters
     * @param {Array.<module:model/RestrictionActionResource>} opts.actions The actions will added to the restriction. Each item includes the information: name, route and verb.
     * @param {module:model/String} opts.mapMode The map mode, it indicates how to handle with the existing items.               The supported values are \&quot;Append\&quot;, \&quot;Reset\&quot;. The defaults is \&quot;Append\&quot;
     * @param {module:api/RestrictionApi~addActionsToRestrictionV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseObject}
     */
    this.addActionsToRestrictionV1 = function(restrictionId, opts, callback) {
      opts = opts || {};
      var postBody = opts['actions'];

      // verify the required parameter 'restrictionId' is set
      if (restrictionId === undefined || restrictionId === null) {
        throw new Error("Missing the required parameter 'restrictionId' when calling addActionsToRestrictionV1");
      }


      var pathParams = {
        'restrictionId': restrictionId
      };
      var queryParams = {
        'mapMode': opts['mapMode'],
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = ResponseObject;

      return this.apiClient.callApi(
        '/api/v1/restrictions/{restrictionId}/actions', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the assignRestrictionToAccountsV1 operation.
     * @callback module:api/RestrictionApi~assignRestrictionToAccountsV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseObject} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Assign a specified restriction to accounts.
     * @param {String} restrictionId The ID of the restriction to be assigned from.
     * @param {Object} opts Optional parameters
     * @param {Array.<String>} opts.accounts The IDs of accounts to be assigned.
     * @param {module:model/String} opts.mapMode The map mode, it indicates how to handle with the existing items.               The supported values are \&quot;Append\&quot;, \&quot;Reset\&quot;. The defaults is \&quot;Append\&quot;
     * @param {module:api/RestrictionApi~assignRestrictionToAccountsV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseObject}
     */
    this.assignRestrictionToAccountsV1 = function(restrictionId, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter 'restrictionId' is set
      if (restrictionId === undefined || restrictionId === null) {
        throw new Error("Missing the required parameter 'restrictionId' when calling assignRestrictionToAccountsV1");
      }


      var pathParams = {
        'restrictionId': restrictionId
      };
      var queryParams = {
        'mapMode': opts['mapMode'],
      };
      var collectionQueryParams = {
        'accounts': {
          value: opts['accounts'],
          collectionFormat: 'multi'
        },
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = ResponseObject;

      return this.apiClient.callApi(
        '/api/v1/restrictions/{restrictionId}/accounts', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the createRestrictionV1 operation.
     * @callback module:api/RestrictionApi~createRestrictionV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseRestrictionResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Create a new restriction.
     * @param {Object} opts Optional parameters
     * @param {module:model/RestrictionResource} opts.restriction The information of the restriction to be created.
     * @param {module:api/RestrictionApi~createRestrictionV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseRestrictionResponse}
     */
    this.createRestrictionV1 = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['restriction'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = ResponseRestrictionResponse;

      return this.apiClient.callApi(
        '/api/v1/restrictions', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the deleteRestrictionByIdV1 operation.
     * @callback module:api/RestrictionApi~deleteRestrictionByIdV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseObject} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Delete the restriction with the specified ID.
     * @param {String} restrictionId The ID of the restriction to be deleted.
     * @param {module:api/RestrictionApi~deleteRestrictionByIdV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseObject}
     */
    this.deleteRestrictionByIdV1 = function(restrictionId, callback) {
      var postBody = null;

      // verify the required parameter 'restrictionId' is set
      if (restrictionId === undefined || restrictionId === null) {
        throw new Error("Missing the required parameter 'restrictionId' when calling deleteRestrictionByIdV1");
      }


      var pathParams = {
        'restrictionId': restrictionId
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = ResponseObject;

      return this.apiClient.callApi(
        '/api/v1/restrictions/{restrictionId}', 'DELETE',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the deletetRestrictionsByIdsV1 operation.
     * @callback module:api/RestrictionApi~deletetRestrictionsByIdsV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseObject} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Delete the restrictions with the specified IDs.
     * @param {Object} opts Optional parameters
     * @param {Array.<String>} opts.restrictionIds The ID of restrictions to be deleted.
     * @param {module:api/RestrictionApi~deletetRestrictionsByIdsV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseObject}
     */
    this.deletetRestrictionsByIdsV1 = function(opts, callback) {
      opts = opts || {};
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
        'restrictionIds': {
          value: opts['restrictionIds'],
          collectionFormat: 'multi'
        },
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = ResponseObject;

      return this.apiClient.callApi(
        '/api/v1/restrictions', 'DELETE',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getApisForRestrictionsV1 operation.
     * @callback module:api/RestrictionApi~getApisForRestrictionsV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseListRestrictionActionResource} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get a collection of APIs that can be used to restriction.
     * @param {module:api/RestrictionApi~getApisForRestrictionsV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseListRestrictionActionResource}
     */
    this.getApisForRestrictionsV1 = function(callback) {
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = ResponseListRestrictionActionResource;

      return this.apiClient.callApi(
        '/api/v1/restrictions/configuration', 'GET',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getPagedRestrictionsV1 operation.
     * @callback module:api/RestrictionApi~getPagedRestrictionsV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/RestrictionsResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get the restrictions in pagination.
     * @param {Object} opts Optional parameters
     * @param {String} opts.type The type of the restriction to query.
     * @param {Number} opts.offset The start index of the records.
     * @param {Number} opts.length The page size of per page.
     * @param {module:model/String} opts.returnMode The return mode, it indicates the information of the restrictions to return.               The supported values are \&quot;All\&quot;, \&quot;CountOnly\&quot;, \&quot;NameOnly\&quot;, \&quot;IdOnly\&quot; and \&quot;UriOnly\&quot;. The defaults is \&quot;All\&quot;
     * @param {String} opts.whereClause The name to search.
     * @param {module:api/RestrictionApi~getPagedRestrictionsV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/RestrictionsResponse}
     */
    this.getPagedRestrictionsV1 = function(opts, callback) {
      opts = opts || {};
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
        'type': opts['type'],
        'offset': opts['offset'],
        'length': opts['length'],
        'returnMode': opts['returnMode'],
        'whereClause': opts['whereClause'],
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = RestrictionsResponse;

      return this.apiClient.callApi(
        '/api/v1/restrictions', 'GET',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getRestrictionByIdV1 operation.
     * @callback module:api/RestrictionApi~getRestrictionByIdV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseRestrictionResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get a restriction by ID.
     * @param {String} restrictionId The ID of the restriction to get.
     * @param {module:api/RestrictionApi~getRestrictionByIdV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseRestrictionResponse}
     */
    this.getRestrictionByIdV1 = function(restrictionId, callback) {
      var postBody = null;

      // verify the required parameter 'restrictionId' is set
      if (restrictionId === undefined || restrictionId === null) {
        throw new Error("Missing the required parameter 'restrictionId' when calling getRestrictionByIdV1");
      }


      var pathParams = {
        'restrictionId': restrictionId
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = ResponseRestrictionResponse;

      return this.apiClient.callApi(
        '/api/v1/restrictions/{restrictionId}', 'GET',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the removeActionsFromRestrictionV1 operation.
     * @callback module:api/RestrictionApi~removeActionsFromRestrictionV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseObject} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Remove the actions from a specificed restriction.
     * @param {String} restrictionId The ID of the restriction that the actions are removed from.
     * @param {Object} opts Optional parameters
     * @param {Array.<module:model/RestrictionActionResource>} opts.actions The actions to be removed.
     * @param {module:api/RestrictionApi~removeActionsFromRestrictionV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseObject}
     */
    this.removeActionsFromRestrictionV1 = function(restrictionId, opts, callback) {
      opts = opts || {};
      var postBody = opts['actions'];

      // verify the required parameter 'restrictionId' is set
      if (restrictionId === undefined || restrictionId === null) {
        throw new Error("Missing the required parameter 'restrictionId' when calling removeActionsFromRestrictionV1");
      }


      var pathParams = {
        'restrictionId': restrictionId
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = ResponseObject;

      return this.apiClient.callApi(
        '/api/v1/restrictions/{restrictionId}/actions', 'DELETE',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the removeRestrictionFromAccountsV1 operation.
     * @callback module:api/RestrictionApi~removeRestrictionFromAccountsV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseObject} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Remove the actions from a specificed restriction.
     * @param {String} restrictionId The ID of the restriction that the actions are removed from.
     * @param {Object} opts Optional parameters
     * @param {Array.<String>} opts.accounts The ID of the accounts to be removed.
     * @param {module:api/RestrictionApi~removeRestrictionFromAccountsV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseObject}
     */
    this.removeRestrictionFromAccountsV1 = function(restrictionId, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter 'restrictionId' is set
      if (restrictionId === undefined || restrictionId === null) {
        throw new Error("Missing the required parameter 'restrictionId' when calling removeRestrictionFromAccountsV1");
      }


      var pathParams = {
        'restrictionId': restrictionId
      };
      var queryParams = {
      };
      var collectionQueryParams = {
        'accounts': {
          value: opts['accounts'],
          collectionFormat: 'multi'
        },
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = ResponseObject;

      return this.apiClient.callApi(
        '/api/v1/restrictions/{restrictionId}/accounts', 'DELETE',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the updateRestrictionV1 operation.
     * @callback module:api/RestrictionApi~updateRestrictionV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseRestrictionResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Updat the restriction.
     * @param {String} restrictionId 
     * @param {Object} opts Optional parameters
     * @param {module:model/RestrictionResource} opts.restriction The new information to be updated for the restriction.
     * @param {module:api/RestrictionApi~updateRestrictionV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseRestrictionResponse}
     */
    this.updateRestrictionV1 = function(restrictionId, opts, callback) {
      opts = opts || {};
      var postBody = opts['restriction'];

      // verify the required parameter 'restrictionId' is set
      if (restrictionId === undefined || restrictionId === null) {
        throw new Error("Missing the required parameter 'restrictionId' when calling updateRestrictionV1");
      }


      var pathParams = {
        'restrictionId': restrictionId
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = ResponseRestrictionResponse;

      return this.apiClient.callApi(
        '/api/v1/restrictions/{restrictionId}', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));

